import { createContext } from 'react';

/** Activity of a covered UI subtree. Keep foreground dialogs outside this provider. */
export const PageActivityContext = createContext(true);
